// extracted by mini-css-extract-plugin
export default {"email-share-link":"email-share-link--mp-ErqpM","emailShareLink":"email-share-link--mp-ErqpM"};